import { create } from "zustand";
import { ProfileData } from "@/interface/profile.types";

interface ProfileState {
  profileData: Partial<ProfileData> | null;
  isLoading: boolean;
  error: string | null;
  setProfile: (userData: ProfileData) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearProfile: () => void;
}

const useProfileStore = create<ProfileState>((set) => ({
  profileData: null,
  isLoading: false,
  error: null,
  setProfile: (profileData) => {
    set(() => ({ profileData, error: null }));
  },
  setLoading: (isLoading) => {
    set(() => ({ isLoading }));
  },
  setError: (error) => {
    set(() => ({ error, isLoading: false }));
  },
  clearProfile: () => {
    set(() => ({ profileData: null, isLoading: false, error: null }));
  },
}));

export default useProfileStore;
